var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.815 1.60167H8.715C8.6 0.786672 7.905 0.151672 7.06 0.151672H5.995C5.15 0.151672 4.455 0.781672 4.34 1.60167H1.245C0.56 1.60167 0 2.16167 0 2.84667V3.04167C0 3.64167 0.43 4.14667 0.995 4.26167L1.965 14.9067H11.095L12.065 4.26167C12.63 4.14667 13.06 3.64167 13.06 3.04167V2.84667C13.06 2.16167 12.5 1.60167 11.815 1.60167ZM6 0.901672H7.065C7.5 0.901672 7.86 1.19667 7.965 1.60167H5.105C5.21 1.20167 5.57 0.901672 6.005 0.901672H6ZM10.415 14.1517H2.65L1.75 4.28167H11.31L10.415 14.1517ZM12.315 3.03667C12.315 3.30667 12.095 3.53167 11.82 3.53167H1.245C0.975 3.53167 0.75 3.31167 0.75 3.03667V2.84167C0.75 2.57167 0.97 2.34667 1.245 2.34667H11.815C12.085 2.34667 12.31 2.56667 12.31 2.84167V3.03667H12.315ZM6.78 12.3367H6.28V6.33667H6.78V12.3367ZM3.99 12.3567L3.51 6.35667L4.01 6.31667L4.49 12.3167L3.99 12.3567ZM9.075 12.3567L8.575 12.3167L9.06 6.31667L9.56 6.35667L9.075 12.3567Z",
    fill: "#0F3250"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.25003bd25bc3114264e1ab8402261da8.svg";
export { ForwardRef as ReactComponent };